import * as React from 'react'
import { LOYALTY_ICON_ID } from '../../utils/enums'

type LoyaltyIconProps = {
	uniqueId: LOYALTY_ICON_ID
}

const LoyaltyIcon = ({ uniqueId }: LoyaltyIconProps) => {
	const filterId = `loyalty-filter-${uniqueId}`
	const gradBId = `loyalty-grad-b-${uniqueId}`
	const gradCId = `loyalty-grad-c-${uniqueId}`
	const gradEId = `loyalty-grad-e-${uniqueId}`
	const maskId = `loyalty-mask-${uniqueId}`

	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={36} height={36} viewBox='0 0 36 36' fill='none'>
			<g filter={`url(#${filterId})`}>
				<path fill={`url(#${gradBId})`} d='m18 3 8.485 3.515L30 15l-3.515 8.485L18 27l-8.485-3.515L6 15l3.515-8.485L18 3Z' />
				<path fill={`url(#${gradCId})`} d='m18 3 8.485 3.515L30 15l-3.515 8.485L18 27l-8.485-3.515L6 15l3.515-8.485L18 3Z' />
				<path stroke='#fff' d='M26.102 6.896 29.459 15l-3.355 8.102L18 26.459l-8.104-3.355L6.541 15l3.355-8.104L18 3.541l8.102 3.355Z' />
			</g>
			<mask id={maskId} width={24} height={24} x={6} y={3} maskUnits='userSpaceOnUse' style={{ maskType: 'alpha' }}>
				<path
					fill='#fff'
					stroke='#fff'
					strokeWidth={0.8}
					d='M26.179 6.82 29.566 15l-3.387 8.179L18 26.566 9.82 23.18 6.433 15 9.82 6.82 18 3.433l8.179 3.387Z'
				/>
			</mask>
			<g mask={`url(#${maskId})`}>
				<path fill={`url(#${gradEId})`} d='M9 29.178h24v3.6H9z' transform='rotate(-23 9 29.178)' />
			</g>
			<defs>
				<linearGradient id={gradBId} x1={17.1} x2={11.7} y1={3} y2={26.1} gradientUnits='userSpaceOnUse'>
					<stop offset={0.222} stopColor='#CF78A5' />
					<stop offset={0.927} stopColor='#8695CA' />
				</linearGradient>
				<linearGradient id={gradCId} x1={15.9} x2={31.2} y1={14.4} y2={12.9} gradientUnits='userSpaceOnUse'>
					<stop stopColor='#DFB6D0' stopOpacity={0} />
					<stop offset={1} stopColor='#DFB6D0' />
				</linearGradient>
				<linearGradient id={gradEId} x1={9} x2={33} y1={30.978} y2={30.978} gradientUnits='userSpaceOnUse'>
					<stop stopColor='#fff' stopOpacity={0.5} />
					<stop offset={0.51} stopColor='#fff' stopOpacity={0.8} />
					<stop offset={1} stopColor='#fff' stopOpacity={0.5} />
				</linearGradient>
				<filter id={filterId} width={36} height={36} x={0} y={0} colorInterpolationFilters='sRGB' filterUnits='userSpaceOnUse'>
					<feFlood floodOpacity={0} result='BackgroundImageFix' />
					<feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' />
					<feOffset dy={3} />
					<feGaussianBlur stdDeviation={3} />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0' />
					<feBlend in2='BackgroundImageFix' result='effect1_dropShadow_18452_70320' />
					<feBlend in='SourceGraphic' in2='effect1_dropShadow_18452_70320' result='shape' />
				</filter>
			</defs>
		</svg>
	)
}

export default LoyaltyIcon
